export default {
    // 分享页面
    shareFinance:() => import( /* webpackChunkName: "shareFinance" */ '../../views/ZEX/shareFinance.vue'),
    // 融资申请页面
	financeApply:() => import( /* webpackChunkName: "financeApple" */ '../../views/ZEX/financeApply.vue'),
    // 二维码
	shareCode:() => import( /* webpackChunkName: "shareCode" */ '../../views/ZEX/shareCode.vue')
}